const LOCALE_TO_LANGUAGE: Record<string, string> = {
  'nl-NL': 'nl',
  'nl-BE': 'be',
};

export const getLanguageFromLocale = (locale: string): string | null => LOCALE_TO_LANGUAGE[locale];
